module.exports = __webpack_public_path__ + "img/logo.6e1e207c.png";